import { render, staticRenderFns } from "./OrderShipmentTable.vue?vue&type=template&id=27d8b47c"
import script from "./OrderShipmentTable.vue?vue&type=script&lang=js"
export * from "./OrderShipmentTable.vue?vue&type=script&lang=js"
import style0 from "./OrderShipmentTable.vue?vue&type=style&index=0&id=27d8b47c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports